import * as _ from 'lodash';
import toastr from 'toastr';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';
import {
  loadContact,
  setFormLoader,
  setLoader,
  upsertContact,
  deleteContact as deleteContactFromRedux,
} from './reducer';

export function loadContacts() {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const response = await ApiService.bulkDownloadContacts();
      const successResponse = _.get(response, 'data.rpcService.success');
      if (!successResponse) {
        throw response;
      }
      const contacts =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (contacts) {
        dispatch(loadContact(contacts));
      } else {
        throw new Error('Contacts not found in api');
      }
    } catch (e) {
      dispatch(loadContact([]));
      logUtils.logError(e, 'Loading Contacts Failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function updateContact(contact) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      const response = await ApiService.upsertContact(contact);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      const updatedContact =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (!updatedContact) throw new Error('Didnt receive updated Contact from api');
      toastr.success('Contact updated');
      dispatch(upsertContact(updatedContact));
    } catch (e) {
      logUtils.logError(e, 'Updating Contact failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function createContact(contact) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      delete contact.id;
      const response = await ApiService.upsertContact(contact);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      const createdContact =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (!createdContact) throw new Error('Contact not created');
      toastr.success('Contact Created');
      dispatch(upsertContact(createdContact));
    } catch (e) {
      logUtils.logError(e, 'Contact creation failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function onSubmitButtonClicked(contact) {
  return async (dispatch) => {
    const clonedContact = _.clone(contact);
    if (contact.id) {
      await updateContact(clonedContact)(dispatch);
    } else {
      await createContact(clonedContact)(dispatch);
    }
  };
}

export function deleteContact(contact) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    const clonedContact = _.clone(contact);
    clonedContact.isDeleted = true;
    try {
      const response = await ApiService.upsertContact(clonedContact);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      dispatch(deleteContactFromRedux(contact));
      toastr.success('Contact Deleted');
    } catch (e) {
      logUtils.logError(e, 'Contact  deleting failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}
